import React, { useMemo } from 'react';

import { useEditionAwareness } from '../../../services/edition-awareness-context';
import { ModalEntryPoint } from '../shared/modal-entry-point';
import { entryPoint, type EntryPointParams } from './collectionTrialModal.entrypoint';
import { DIALOG_CONFIG } from './dialog-config';

const modalProps = { width: 'medium' as const };

export const CollectionTrialModal = (): React.JSX.Element => {
	const { collectionEntitlementId } = useEditionAwareness();

	const entryPointParams: EntryPointParams = useMemo(
		() => ({
			collectionEntitlementId: `ari:cloud:commerce::entitlement/${collectionEntitlementId}`,
		}),
		[collectionEntitlementId],
	);

	return (
		<ModalEntryPoint
			entryPoint={entryPoint}
			entryPointParams={entryPointParams}
			modalProps={modalProps}
			dialogConfig={DIALOG_CONFIG}
		/>
	);
};
